import React, { useState } from "react";
import "./Order_details_table.css";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faTrashCan } from "@fortawesome/free-solid-svg-icons";
import { Table, Form } from "react-bootstrap";
import { Link, useNavigate } from "react-router-dom";
import { encodeId, variant_type, getVariantImage } from "../../../../utils/common";
import Brown_btn from "../../../common-components/common_btn/brown_btn/Brown_btn";
import Gray_Btn from "../../../common-components/common_btn/gray_btn/Gray_Btn";
import Green_btn from "../../../common-components/common_btn/green_btn/Green_btn";
import { useSelector } from "react-redux";

function Order_details_table({
  order,
  selectedItems,
  setSelectedItems,
  setError,
  setProductId,
  setShowReviewRating,
  showReviewRating,
}) {
  const handleCheckboxChange = (val) => {
    setError("");
    setSelectedItems((prev) => {
      const exists = prev.some((item) => item.id === val.id);
      if (exists) {
        return prev.filter((item) => item.id !== val.id);
      } else {
        return [...prev, val];
      }
    });
  };

  const handleOpenReview = async (productDetail) => {
    await setProductId(productDetail?.product_id);
    await setShowReviewRating(true);
  };
  const appSetupdata = useSelector((state) => state.master.app_setup);
  const [errorMessage, setErrorMessage] = useState("");
  const navigate = useNavigate();
  const isReturnPeriodValid = (updatedAt, returnPeriod) => {
    const updatedDate = new Date(updatedAt);
    const today = new Date();
    const diffInDays = Math.floor(
      (today - updatedDate) / (1000 * 60 * 60 * 24),
    );

    return diffInDays <= Number(returnPeriod);
  };
  const handleReplaceClick = (id) => {
    const returnPeriod = Number(appSetupdata?.return_period);
    const updatedAt = order?.updatedAt;

    const isValid = isReturnPeriodValid(updatedAt, returnPeriod);

    if (!isValid) {
      setErrorMessage(
        "replace period has expired. You can't Replace this order.",
      );
    } else {
      setErrorMessage("");
      navigate(`/replace-order/${encodeId(id)}`);
    }
  };

  const handleProductClick = (productId, deletedAt) => {
    if (deletedAt === null) {
      navigate(`/product-details/${encodeId(productId)}`);
    }
  };

  return (
    <>
      <section className="Order_details_table Cart_Products_card d-none d-lg-block">
        <div className="inner_box_div">
          {order?.Product_Order_Details?.map((val) => (
            <div className="row align-items-center inner_card">
              <div className="col-sm-8 ">
                {/* <Link
                  href={`/product-details/${encodeId(val?.Product?.id)}`}
                  className="text-decoration-none text-dark"
                > */}
                <div
                  className="text-decoration-none text-dark"
                  onClick={() =>
                    handleProductClick(
                      val?.Product?.id,
                      val?.Product?.deletedAt,
                    )
                  }
                  style={{
                    cursor:
                      val?.Product?.deletedAt === null ? "pointer" : "default",
                  }}
                >
                  <div className="row">
                    <div className="col-xxl-2 col-xl-3 col-lg-3 col-md-3 col-3">
                      <div className="img_holder">
                        <img
                          className="Product_img"
                          src={
                            getVariantImage(val)
                          }
                          alt="Product_img"
                        />
                      </div>
                    </div>

                    <div className="col-xxl-10 col-xl-9 col-lg-9 col-md-9 col-9">
                      <div className="info_text_holder">
                        <div>
                          <h4>{val?.Product?.name}</h4>
                          <div className="new">
                            {val?.Product?.variant_type_id ===
                              variant_type.Single && (
                              <>
                                {/* <>Variant :</>{" "} */}
                                <>
                                  <strong>
                                    {val?.Product?.variant_name} :{" "}
                                  </strong>
                                </>{" "}
                                {val?.Product_Variant?.Metal?.name}
                              </>
                            )}

                            {val?.Product?.variant_type_id ===
                              variant_type.Double && (
                              <>
                                {/* <>Variant :</>{" "} */}
                                <>
                                  <strong>
                                    {val?.Product?.variant_name} :
                                  </strong>
                                </>{" "}
                                {
                                  val?.Double_Variant?.Product_Variant?.Metal
                                    ?.name
                                }
                                <br></br>
                                <strong>Size :</strong>{" "}
                                {val?.Double_Variant?.Size?.name}{" "}
                              </>
                            )}

                            {val?.Product?.variant_type_id ===
                              variant_type.Triple && (
                              <>
                                {/* <>Variant :</>{" "} */}
                                <>
                                  <strong>
                                    {val?.Product?.variant_name} :
                                  </strong>
                                </>{" "}
                                {
                                  val?.Triple_Variant?.Double_Variant
                                    ?.Product_Variant?.Metal?.name
                                }
                                <br></br>
                                <strong>Size:</strong>{" "}
                                {
                                  val?.Triple_Variant?.Double_Variant?.Size
                                    ?.name
                                }
                                , <strong>Diamond:</strong>{" "}
                                {val?.Triple_Variant?.Diamond?.name}
                              </>
                            )}
                          </div>

                          {val?.Product_Variant?.name && (
                            <p className="mb-1">
                              <strong>Polish :</strong>{" "}
                              {val?.Product_Variant?.name}
                            </p>
                          )}

                          {val?.Double_Variant?.name && (
                            <p className="mb-1">
                              <strong>Colour :</strong>{" "}
                              {val?.Double_Variant?.name}
                            </p>
                          )}

                          {val?.Triple_Variant?.name && (
                            <p className="mb-1">
                              <strong>Size :</strong>{" "}
                              {val?.Triple_Variant?.name}
                            </p>
                          )}
                        </div>
                      </div>
                    </div>
                  </div>
                </div>

                {val?.Product?.Rating_Reviews === null && (
                  <div className="mt-2">
                    <button
                      className="btn btn-success btn-sm"
                      onClick={() => handleOpenReview(val)}
                    >
                      Review & Rating
                    </button>
                  </div>
                )}
              </div>

              <div className="col-sm-4 ">
                <div className="new_price_holder">
                  <div className="price_inner_text">
                    <p className="right_label">Price </p>
                    <p className="colon_text">:</p>₹{val?.selling_price}
                  </div>

                  <div className="price_inner_text">
                    <p className="right_label">Order Qty </p>
                    <p className="colon_text">:</p>{val?.quantity}
                  </div>

                  <div className="price_inner_text">
                    <p className="right_label">Total Price </p>
                    <p className="colon_text">:</p>₹{" "}
                    {val?.quantity * val?.selling_price}
                  </div>
                </div>
                {order?.order_status_id === 6 && val?.Product?.is_replaceble && (
                  <div>
                    <button
                      className="Downloadinvoicebtn"
                      onClick={() => handleReplaceClick(val?.id)}
                    >
                      Replace Order
                    </button>
                  </div>
                )}
              </div>
            </div>
          ))}
        </div>
      </section>

      <div className="d-block d-lg-none mobile_view_holder">
        {order?.Product_Order_Details?.map((val) => (
          <div className="mobile_product_card" key={val?.id}>
            {/* <Link
              href={`/product-details/${val?.Product?.id}`}
              className="text-decoration-none text-dark"
            > */}
            <div
              className="text-decoration-none text-dark"
              onClick={() =>
                handleProductClick(val?.Product?.id, val?.Product?.deletedAt)
              }
              style={{
                cursor:
                  val?.Product?.deletedAt === null ? "pointer" : "default",
              }}
            >
              <div className="order_holder">
                <div className="order_holder_left">
                  <div className="img_holder">
                    <img
                      className="Product_img"
                      src={getVariantImage(val)}
                      alt={val?.Product?.name}
                    />
                  </div>
                </div>

                <div className="order_holder_right">
                  <div className="descn_holder">
                    <div className="left_div">
                      <h6 className="product_name mb-2">
                        {val?.Product?.name}
                      </h6>

                      <div className="new">
                        {val?.Product?.variant_type_id ===
                          variant_type.Single && (
                          <>
                            {/* <>Variant :</>{" "} */}
                            <>
                              <strong>{val?.Product?.variant_name} : </strong>
                            </>{" "}
                            {val?.Product_Variant?.Metal?.name}
                          </>
                        )}

                        {val?.Product?.variant_type_id ===
                          variant_type.Double && (
                          <>
                            {/* <>Variant :</>{" "} */}
                            <>
                              <strong>{val?.Product?.variant_name} :</strong>
                            </>{" "}
                            {val?.Double_Variant?.Product_Variant?.Metal?.name}
                            <br></br>
                            <strong>Size :</strong>{" "}
                            {val?.Double_Variant?.Size?.name}{" "}
                          </>
                        )}

                        {val?.Product?.variant_type_id ===
                          variant_type.Triple && (
                          <>
                            {/* <>Variant :</>{" "} */}
                            <>
                              <strong>{val?.Product?.variant_name} :</strong>
                            </>{" "}
                            {
                              val?.Triple_Variant?.Double_Variant
                                ?.Product_Variant?.Metal?.name
                            }
                            <br></br>
                            <strong>Size:</strong>{" "}
                            {val?.Triple_Variant?.Double_Variant?.Size?.name},{" "}
                            <strong>Diamond:</strong>{" "}
                            {val?.Triple_Variant?.Diamond?.name}
                          </>
                        )}
                      </div>

                      {val?.Product_Variant?.name && (
                        <p className="mb-1">
                          <strong>Polish :</strong> {val?.Product_Variant?.name}
                        </p>
                      )}

                      {val?.Double_Variant?.name && (
                        <p className="mb-1">
                          <strong>Colour :</strong> {val?.Double_Variant?.name}
                        </p>
                      )}

                      {val?.Triple_Variant?.name && (
                        <p className="mb-1">
                          <strong>Size :</strong> {val?.Triple_Variant?.name}
                        </p>
                      )}
                    </div>

                    <div className="price_details">
                      <p className="mb-1">
                        <strong>₹{val?.selling_price}</strong> X {val?.quantity}
                      </p>

                      {/* <p className="mb-1">
                        <strong>Order Qty :</strong> {val?.quantity}
                      </p> */}

                      {/* <p className="mb-0">
                        <strong>Total Price :</strong> ₹
                        {val?.quantity * val?.selling_price}
                      </p> */}
                    </div>
                  </div>
                </div>
              </div>
            </div>

            {val?.Product?.Rating_Reviews === null && (
              <div className="mt-3">
                <button
                  className="btn btn-success btn-sm w-100"
                  onClick={() => handleOpenReview(val)}
                >
                  Review & Rating
                </button>
              </div>
            )}
          </div>
        ))}
      </div>
    </>
  );
}

export default Order_details_table;
